import { Component, OnInit } from '@angular/core';
import { UserService } from '../../_services/user.service';
import { MatDialog } from '@angular/material';
import { SaveMessageComponent } from '../../directive/save-message/save-message.component';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { AngularFirestore } from 'angularfire2/firestore';
import { Http } from '@angular/http';

@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.css']
})
export class AccountSettingsComponent implements OnInit {
  userId = this.userService.getUid();
  users: Observable<any>;
  secretVal: any;
  user: any;
  smsVal: any;
  ipAddress: any;
  private subscription: Subscription = new Subscription();

  constructor(
    private afs: AngularFirestore,
    private _http: Http,
    private dialog: MatDialog, private userService: UserService) {
    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.user = user;
      this.secretVal = user.isSecret
      if (user.isSms == null) {
        user.isSms = true;
      }
      this.smsVal = user.isSms
    }));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.getIpAdress();
  }

  getIpAdress() {
    this.subscription.add(this._http.get("https://api.bigadvice.com/helper/ip")
      .map(data => { this.ipAddress = data.json() }).subscribe());
  }


  onSubmit(f) {
    this.afs.collection('users').doc(this.userId).update({
      isSecret: this.secretVal,
      isSms: this.smsVal
    }).then(() => {
      this.userService.userLog('account-settings', this.ipAddress);


    })
    this.dialog.open(SaveMessageComponent, {
      width: '400px',
      data: {
        message: "Değişiklikler kaydedildi.",
        type: "update"
      }
    });

  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/profile-update/account-settings/account-settings.component.ts